import React from "react";
import "../CSS_stuff/contact.css";
import fbLogo from "../assets/Facebook_Logo_Primary.png";

const Contact = () => {
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>Have questions? Feel free to reach out!</p>

      <div className="contact-info">
        <p>
          You can reach Mangala McNamara at:{" "}
          <a href="mailto:MangalaMcNamara@risingdragonbooks.com">
            MangalaMcNamara@RisingDragonBooks.com
          </a>
        </p>
        <p>Ask me a question or let me know what you thought of something I wrote!</p>
        <p>I would love to hear from you!</p>
      </div>

      <div className="contact-social">
        <p>Follow me on Facebook:</p>
        <a
          href="https://www.facebook.com/RisingDragonBooks"
          target="_blank"
          rel="noopener noreferrer"
          className="facebook-link"
        >
          <img
            src={fbLogo}
            alt="Facebook logo"
            className="facebook-icon"
          />
        </a>
      </div>

    </div>
  );
};

export default Contact;